import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import useLenis from "@/hooks/useLenis";
import CustomCursor from "@/components/CustomCursor";
import LoadingScreen from "@/components/LoadingScreen";
import IntroHero from "@/components/IntroHero";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import SelectedWork from "@/components/SelectedWork";
import TypographicTransition from "@/components/TypographicTransition";
import WhoWeAre from "@/components/WhoWeAre";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CaseStudy from "@/pages/CaseStudy";

function Landing() {
  const [introDone, setIntroDone] = useState(() => {
    try {
      return sessionStorage.getItem("michi_intro_seen") === "1";
    } catch (e) {
      return false;
    }
  });

  // Lock scroll while intro is visible + always start at the very top so the
  // page reveal begins with the Hero, never with a restored scroll position.
  useEffect(() => {
    if (!introDone) {
      // Disable browser scroll restoration so a reload always starts at 0
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
      window.scrollTo(0, 0);
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      document.body.style.overflow = "hidden";
      if (window.__lenis) window.__lenis.stop();
    } else {
      document.body.style.overflow = "";
      // Make absolutely sure we land on the Hero when the intro finishes
      window.scrollTo(0, 0);
      if (window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true });
        window.__lenis.start();
      }
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [introDone]);

  return (
    <>
      {!introDone && <IntroHero onEnter={() => setIntroDone(true)} />}
      <Nav />
      <main>
        <Hero />
        <WhoWeAre />
        <Services />
        <SelectedWork />
        <TypographicTransition />
        <Pricing />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function CaseStudyWithLoader() {
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(() => {
    // Only show loader on hard navigations (not client-side transitions)
    try {
      return !sessionStorage.getItem("michi_intro_seen");
    } catch (e) {
      return true;
    }
  });
  useEffect(() => {
    if (showLoader) {
      try { sessionStorage.setItem("michi_intro_seen", "1"); } catch (e) { /* ignore */ }
    }
  }, [showLoader, location.pathname]);
  return (
    <>
      {showLoader && <LoadingScreen />}
      <CaseStudy />
    </>
  );
}

function App() {
  useLenis();

  return (
    <div className="App noise relative">
      <CustomCursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/proyectos/:slug" element={<CaseStudyWithLoader />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            background: "#111111",
            color: "#FAF8F5",
            border: "1px solid rgba(255,255,255,0.08)",
            fontFamily: "Manrope, sans-serif",
            fontSize: "13px",
            borderRadius: "0",
          },
        }}
      />
    </div>
  );
}

export default App;
